import { Box, Grid, MenuItem, Modal, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import { useFormik } from 'formik';
import ArySelect from 'framework/base/components/ArySelect';
import { fontSizes } from 'framework/base/constants/arySystemSettings';
// import { systemSettingsValidationSchema } from 'pages/validations/aryFormValidations';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import React, { useEffect, useState } from 'react';
import { useStore } from 'react-redux';
import { setDoBootstrap } from 'redux/slices/systemSlice';
import { EDIT_USERS_SETTINGS } from '../constants/aryGraphqlSchemas';
import { useAryMutation } from '../hooks/useAryGraphql';
import useSystemSettingsContext from '../hooks/useSystemSettingsContext';
import AryLoadingButton from './AryLoadingButton';

function PreventZoomModal({ x, y, open, onClose, data }) {
  const theme = useTheme();
  const { t } = useFrameworkTranslation();
  const reduxStore = useStore();
   const { systemSettings } = useSystemSettingsContext();

  const modalStyle = {
    position: 'absolute',
    top: y,
    left: x,
    width: '20rem',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    padding: '1.75rem',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    zIndex: 100000000
  };

  const [editUserSettings, { loading: editUserSettingsLoading }] =
    useAryMutation(EDIT_USERS_SETTINGS);

  const [fontSize, setFontSize] = useState(null);

  useEffect(() => {
    if (data?.fontSize) {
      setFontSize(data?.fontSize);
    }
  }, [data?.fontSize]);

  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box style={modalStyle} className="custom-modal">
        <Grid container rowSpacing={theme.padding.gridSmallRowSpacing}>
          <Grid item xs={12}>
            <Typography color={theme.text.grey800.color}>
              {t('PreventZoomModalTitle')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ArySelect
              label={t('FontSize')}
              value={fontSize}
              onChange={(event) => setFontSize(event.target.value)}
              sx={{
                '& .MuiSelect-select': {
                  color: `${theme.text.grey800.color}!important`
                }
              }}
            >
              <MenuItem value={fontSizes.large}>{t('large')}</MenuItem>
              <MenuItem value={fontSizes.medium}>{t('medium')}</MenuItem>
              <MenuItem value={fontSizes.small}>{t('small')}</MenuItem>
            </ArySelect>
          </Grid>
          <Grid item xs={12}>
            <AryLoadingButton
              loading={editUserSettingsLoading}
              size="small"
              variant="contained"
              onClick={async () => {
                await editUserSettings({
                  fontSize,
                  isDarkMode: systemSettings.isDarkMode,
                  cashAccountId: systemSettings.cashAccountId,
                  isDigitsLatin: systemSettings.isDigitsLatin,
                  language: systemSettings.systemLanguage
                });
                reduxStore.dispatch(setDoBootstrap(true));
                window.location.reload();
                onClose();
              }}
            >
              {t('Submit')}
            </AryLoadingButton>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default PreventZoomModal;
